// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d0e18cc","455":"d881f154","977":"43282e20"}[chunkId] + ".chunk.js";
};